import React from 'react';
import ConsultantLayout from './ConsultantLayout';
import SolutionPartnerLayout from './SolutionPartnerLayout';

/*
 * Which shell a staff route renders in.
 *
 * A Solution Partner works one assigned client at a time and gets the portal
 * shell built for that: four destinations and a client switcher in the chrome.
 * A super is platform authority spanning every account and keeps the console
 * with its two decks. They are different jobs, so they are different shells,
 * and this is the one place that decision is made.
 */

const StaffShell: React.FC = () => {
  const role = localStorage.getItem('user_role');
  if (role === 'consultant') return <SolutionPartnerLayout />;
  return <ConsultantLayout />;
};

export default StaffShell;
